import { useThemeStore } from '../store/themeStore';
import { usePreferencesStore } from '../store/preferencesStore';
import { normalizeTerminalTheme } from '../utils/terminalTheme';

/**
 * Is the TERMINAL dark? Settings → Extensions → Terminal → Theme (owner,
 * 05.10.2026): 'follow' (default) uses the app theme, as VS Code and JetBrains
 * do; 'dark' keeps the Warp-style always-dark surface the terminal had before;
 * 'light' is always light. The app theme itself is 'light' | 'dark' |
 * 'system' (themeStore).
 */
export function resolveTerminalIsDark(appTheme, terminalTheme) {
  const choice = normalizeTerminalTheme(terminalTheme);
  if (choice === 'dark') return true;
  if (choice === 'light') return false;
  return (
    appTheme === 'dark' ||
    (appTheme === 'system' &&
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-color-scheme: dark)').matches)
  );
}

/** The hook every terminal surface uses (xterm theme + pane chrome). */
export function useTerminalIsDark() {
  const appTheme = useThemeStore((s) => s.theme);
  const terminalTheme = usePreferencesStore((s) => s.terminalTheme);
  return resolveTerminalIsDark(appTheme, terminalTheme);
}
